var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"target"},[_c('h3',[_vm._v("Название цели")]),_c('v-text-field',{staticClass:"my_textarea",attrs:{"name":"input-7-1","placeholder":""},on:{"input":_vm.input},model:{value:(_vm.data_local.name),callback:function ($$v) {_vm.$set(_vm.data_local, "name", $$v)},expression:"data_local.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }